export function PageHeader({ overline, title, subtitle, actions }) {
  return (
    <div className="mb-8 flex flex-col md:flex-row md:items-end md:justify-between gap-4" data-testid="page-header">
      <div>
        {overline && (
          <div className="text-xs font-semibold uppercase tracking-[0.25em] text-[#A67B5B] mb-2" data-testid="page-overline">
            {overline}
          </div>
        )}
        <h1 className="font-heading text-4xl sm:text-5xl text-deep tracking-tight leading-none" data-testid="page-title">
          {title}
        </h1>
        {subtitle && <p className="mt-2 text-base text-warm max-w-2xl">{subtitle}</p>}
      </div>
      {actions && <div className="flex gap-2">{actions}</div>}
    </div>
  );
}

export function Panel({ title, action, children, className = "" }) {
  return (
    <section className={`bg-white border border-warm rounded-lg ${className}`}>
      {(title || action) && (
        <header className="px-6 py-4 flex items-center justify-between border-b border-warm">
          {title && <h3 className="font-medium text-deep">{title}</h3>}
          {action}
        </header>
      )}
      <div className="p-6">{children}</div>
    </section>
  );
}

export function StatusPill({ status }) {
  const map = {
    paid: "bg-[#DCE3D6] text-[#4A5D3E]",
    approved: "bg-[#DCE3D6] text-[#4A5D3E]",
    resolved: "bg-[#DCE3D6] text-[#4A5D3E]",
    closed: "bg-[#EAE5DE] text-[#5A5652]",
    unpaid: "bg-[#FBEED7] text-[#8C6D31]",
    pending: "bg-[#FBEED7] text-[#8C6D31]",
    open: "bg-[#FBEED7] text-[#8C6D31]",
    in_progress: "bg-[#D6E6EB] text-[#3D5C68]",
    rejected: "bg-[#F5D8D8] text-[#8C3F3F]",
    active: "bg-[#DCE3D6] text-[#4A5D3E]",
    inactive: "bg-[#EAE5DE] text-[#5A5652]",
  };
  const cls = map[status] || "bg-[#F4F1EA] text-[#75716E]";
  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium capitalize ${cls}`}>
      {String(status).replace(/_/g, " ")}
    </span>
  );
}

export function EmptyState({ title, hint, image }) {
  return (
    <div className="text-center py-14" data-testid="empty-state">
      {image && <img src={image} alt="" className="h-32 mx-auto mb-6 opacity-90 rounded-md" />}
      <div className="font-heading text-2xl text-deep">{title}</div>
      {hint && <div className="text-warm mt-2 text-sm max-w-md mx-auto">{hint}</div>}
    </div>
  );
}
